import React, { useEffect } from 'react';
import * as Templates from './templates';
import Stories from '../stories/Stories/Stories';
import * as Story from '../stories';
import { checkNested, getImage } from 'components/utils';
import { useLocation } from 'react-router-dom';
import { Helmet } from "react-helmet";

const DynamicPage = ({ cms, content, page, componentList }) => {
   let location = useLocation();

   useEffect(() => {
      // Set title tag by page title on location changed.
      document.title = getDocumentTitle(cms,content,location);
   }, [location, cms, content]);
   
   function renderPage() {  
      switch(page){
         case "stories":
            return renderStories();
         case "story":
            return renderStory();
         case "content":
            return renderContent();
         default:
            return renderDefault(); 
      }
   }

   function renderStories() {
      return <Stories
         cms={cms}
         articles={componentList}
      />
   }

   function renderStory() {
     if(componentList.length === 1){
        const componentObj = cms.components[componentList[0]];
        let components = { id: componentList[0], title: content.title, url: content.url, ...componentObj };
        return <Story.Article
            cms={cms}
            components={components}
         />
     }
   }

   function renderContent() {
      if(componentList.length === 1){
         const componentObj = cms.components[componentList[0]];
         let renderComponents = components => components.map((component, i) =>
            component ?
               <div key={component.type + i}>
                  {getComponent(component)}
               </div> : null
         );
         let renderMetadata = (title, metadata) => {
            let getOgImage = metadata => {
               if(metadata && metadata.ogImage) {
                  return getImage(metadata.ogImage, null, true);
               } else if (componentObj.components.length > 0 && componentObj.components[0].type === 'heroBanner'){
                  // If page has Hero banner with image then set this image to OG Image
                  if (componentObj.components[0].image){
                     return getImage(componentObj.components[0].image, null, true);
                  } else if (componentObj.components[0].video) {
                     return getImage(componentObj.components[0].video, null, true);
                  } else {
                     return '/resources/images/global/movember_thumbnail.png';
                  }
               } else {
                  return '/resources/images/global/movember_thumbnail.png';
               }
            }
            let newMeta = {
               title: metadata && metadata.metaTitle ? metadata.metaTitle : title,
               description: metadata && metadata.metaDescription ? metadata.metaDescription : null
            }
            newMeta.ogTitle = metadata && metadata.ogTitle ? metadata.ogTitle : newMeta.title;
            newMeta.ogDescription = metadata && metadata.ogDescription ? metadata.ogDescription : newMeta.description;
            newMeta.ogImage = getOgImage(metadata);

            return (
               <Helmet>
                  <meta name="title" content={newMeta.title} />
                  <meta name="description" content={newMeta.description ? newMeta.description : ''} />
                  <meta name="url" content={window.location.href}  />
                  <meta property="og:title" content={newMeta.ogTitle} />
                  <meta property="og:description" content={newMeta.ogDescription ? newMeta.ogDescription : ''} />
                  <meta property="og:image" content={newMeta.ogImage} />
                  <meta property="og:url" content={window.location.href} />
                  <meta property="og:type" content={"content"}/>
               </Helmet>
            );
         }
         return <div>
            {renderMetadata(content.title, componentObj.metadata)}
            {renderComponents(componentObj.components)}
         </div>
      }
   }

   function renderDefault() {
      return componentList.map((componentId, index) =>
         <div key={componentId + index}>{getComponent(componentId)}</div>
      );
   }

   function getDocumentTitle(cms, content, location) {
      let docTitle = "";

      // Below is the behaviour has discussed with the Tom
      // Set meta title if avilable for both Home and dynamic pages
      if(checkNested(content, 'components', 0) && checkNested(cms, 'components', content.components[0], 'metadata', 'metaTitle')){
         docTitle = cms.components[content.components[0]].metadata.metaTitle;
      }

      // set Title from page if mata title is not avilable
      if(!docTitle  && content && content.title){
         docTitle = content.title;
      }

      //fallback to site settings for if ther are any edge cases
      if(!docTitle && checkNested(cms, 'siteSettings', 'metadata', 'title')){
         docTitle = cms.siteSettings.metadata.title;
      }

      return `${docTitle} ${docTitle.length > 0 ? ' - Movember' : 'Movember'}`;
   }

   function getComponent(componentObj) {
      switch (componentObj && componentObj.type && componentObj.type.toLowerCase()) {
         case "herovideo":
            return <Templates.HeroVideo {...componentObj} />
         case 'getinvolved':
            return <Templates.GetInvolved {...componentObj} />
         case 'programcarousel':
            return <Templates.ProgramCarousel {...componentObj} />
         case 'autoplaycarousel':
            return <Templates.AutoplayCarousel {...componentObj}/>
         case 'socialproof':
            return <Templates.SocialProof {...componentObj} />
         case 'marquee':
            return <Templates.Marquee {...componentObj} />
         case 'twocolumnblock':
            return <Templates.Block2Column {...componentObj} />
         case 'richtextblock':
            return <Templates.RichTextBlock {...componentObj} />
         case 'accordion':
            return <Templates.Accordion {...componentObj} />
         case 'herobanner':
            return <Templates.HeroBanner {...componentObj} />
         case 'multicolumn':
            return <Templates.MultiColumn {...componentObj} />
         case 'membertally':
            return <Templates.MemberTally {...componentObj} />
         case 'tcamheader':
            return <Templates.TcamHeader {...componentObj} />
         case 'testimonial':
            return <Templates.Testimonial {...componentObj} />
         case 'dataform':
            return <Templates.DataForm cms={cms} {...componentObj} />
         default:
            return null;
      }
   }

   return (
      <React.Fragment>
         {renderPage()}
      </React.Fragment>
   );
}
 
export default DynamicPage;